import { CONVERSATION_TYPES } from '@/store/constants'

const HINT_TEXT = Object.freeze({
  QUICK_REPLIES: 'Answer with Quick Replies cannot have more content.',
  BLOCK: 'To modify, open the block editor and change its answer end to "continue".'
})

const CUSTOMER_TEXT = {
  WAIT_FOR_INPUT: 'Customer replies with something . . .',
  WAIT_FOR_VALIDATED_INPUT: contextKey => `User input is saved as <code>${'${context.' + contextKey + '}'}</code>`
}

const CHART_TEXT = Object.freeze({
  REQUEST_HINT: `A <b>request</b> starts with a customer enquiry ("Hello, I'm looking for my PIN.")
    and ends when the enquiry is completely solved (even unsuccessfully).`,
  CONTACT_HINT: `A <b>contact</b>  represents a customer that made at least one interaction via a
    messaging channel (Facebook Messenger, Amio Chat, ...) with your business. A contact can have
    multiple requests.`,
  REQUEST_ANSWERED_BY_BOT_HINT: `Shows how many <b>requests</b> were automatically answered by the bot.
    <br /><br />
    It is not correlated with customer satisfaction.
    <br /><br />
    Check the <b>Customer feedback</b> chart to get an
    overview of customer satisfaction with the bot's answer.`,
  CONTACT_ANSWERED_BY_BOT_HINT: `Shows the percentage of contacts with at least one Fully Automated
    request.`,
  AUTOMATION_RATE_HINT_REQUEST: `Chart sums up <b>outcomes of every request</b> per category.
    <br /><br />
    For example, if a contact has requests with the outcomes "Fully automated", "Fully automated"
    and "Wrong answer", it will add 2 to "Fully automated" and 1 to "Wrong answer".`,
  AUTOMATION_RATE_HINT_CONTACT: `Chart shows how many <b>contacts</b> have encountered each
    <b>request outcome</b>.
    <br /><br />
    For example, if a contact has requests with the outcomes "Fully automated", "Fully automated"
    and "Wrong answer", it will add 1 to "Fully automated" and 1 to "Wrong answer".`,
  REQUEST_ASSISTANCE_TYPE_HINT: `The chart shows the resolution of every <b>request</b>.
    <br /><br />`,
  CONTACT_ASSISTANCE_TYPE_HINT: `Chart shows how many contacts have received each type of
    assistance. One contact might be represented in multiple categories if the contact has made
    multiple requests with different type of assistance.
    <br /><br />`,
  PUBLISHED_ANSWERS_HINT: `Shows how many answers are <b>published</b> (the left number) in contrast
    to the total number of answers (the right number).`
})

const ENABLE_AUTO_TRANSLATE_TEXT = Object.freeze({
  title: 'Enable auto-translate?',
  getDescription: (itemName, marketName, itemType = 'answer') =>
    `Changes to the source ${itemType} will be automatically translated and applied to <strong>"${itemName}"</strong> for the <strong>${marketName}</strong> market.
    <br /><br />
    ⚠️ Existing edits will be lost.`,
  confirm: 'Enable auto-translate'
})

const DELETE_TEXT = Object.freeze({
  [CONVERSATION_TYPES.ANSWERS]: {
    title: 'Delete Answer?',
    getDescription: (answerName) => `This will delete "${answerName}". It cannot be undone.`,
    confirm: 'Delete Answer'
  },
  [CONVERSATION_TYPES.EVENTS]: {
    title: 'Delete Event?',
    getDescription: (eventName) => `This will delete "${eventName}". It cannot be undone.`,
    confirm: 'Delete Event'
  },
  [CONVERSATION_TYPES.TEMPLATES]: {
    title: 'Delete Block?',
    getDescription: (blockName) => `This will delete "${blockName}". It cannot be undone.`,
    confirm: 'Delete Block'
  }
})

const INLINE_BLOCK_TEXT = Object.freeze({
  title: 'Inline block & delete?',
  getDescription: (blockName) =>
    `This will copy "${blockName}" into every Answer and Event that uses it, then delete the block. It cannot be undone.`,
  confirm: 'Inline block & delete'
})

const CREATE_BUTTON_LABELS = {
  DEFAULT: 'Create',
  ERROR: 'Create failed!',
  SUCCESS: 'Created!'
}

const SAVE_BUTTON_LABELS = {
  DEFAULT: 'Save changes',
  ERROR: 'Saving failed!',
  SUCCESS: 'Saved!'
}

const PUBLISHED_ANSWER_TOOLTIP_TEXT = Object.freeze({
  PUBLISHED: 'The Virtual Assistant will reply to your customers with this answer in the current market.',
  NOT_PUBLISHED: 'The Virtual Assistant will not use this answer in the current market.',
  UNKNOWN_ANSWER: '<b>Unknown Answer</b> is always published. Your chatbot will use this reply when it does not understand the customer query.'
})

const PUBLISHED_ANSWER_TOOLTIP_TITLE = Object.freeze({
  PUBLISHED: 'Current market is published',
  NOT_PUBLISHED: 'Current market is unpublished',
  PUBLISH_ACTION: 'Publish current market of the answer',
  UNPUBLISH_ACTION: 'Unpublish current market of the answer'
})

const DEFAULT_EXTRACT_PROMPT = 'Extract all important information from the following text and format it as a markdown bullet list. Do not comment on the text, just extract the information.'

export {
  HINT_TEXT,
  CUSTOMER_TEXT,
  CHART_TEXT,
  ENABLE_AUTO_TRANSLATE_TEXT,
  DELETE_TEXT,
  INLINE_BLOCK_TEXT,
  SAVE_BUTTON_LABELS,
  CREATE_BUTTON_LABELS,
  DEFAULT_EXTRACT_PROMPT,
  PUBLISHED_ANSWER_TOOLTIP_TEXT,
  PUBLISHED_ANSWER_TOOLTIP_TITLE
}
